import { Item, PanelBlock } from '../../types'

const ULTRA_RAIL_SPACING_MM = 19.05
const MM_PER_INCH = 25.4

const SKIRT_RAIL_LENGTH_INCHES = 83
const UNIVERSAL_SKIRT_RAIL_83_CODE = '232-02493-USA'
const SKIRT_FRAME_MOUNT_CODE = '242-10006'
const SKIRT_SPLICE_CONNECTOR_CODE = '242-02156-USA'
const SKIRT_END_CAP_CODE = '232-10019'
const DEFAULT_SKIRT_SPACER_CODE = '232-02532-USA'
const SNOW_LOAD_PSF_THRESHOLD = 90

function bomItems(code: string, count: number): Item[] {
  return Array.from({ length: count }, () => ({ name: code, components: [] }))
}

/**
 * Bottom row length in mm for skirt BOM (no end-clamp allowance).
 * Uses only active panels in the last row.
 */
export function computeBottomRowLengthMmForSkirt(block: PanelBlock): number {
  if (block.rows.length === 0) return 0
  const panelDimensionMm = block.orientation === 'portrait' ? block.panel.width : block.panel.height
  const lastRow = block.rows[block.rows.length - 1]
  const activeCount = lastRow.filter((p) => p.isActive).length
  if (activeCount === 0) return 0
  const panelLength = activeCount * panelDimensionMm
  const gapLength = (activeCount - 1) * ULTRA_RAIL_SPACING_MM
  return panelLength + gapLength
}

export interface UniversalSkirtRailBomParams {
  bottomRowLengthMm: number
  designSnowLoad?: number
  skirtRailSpacer?: string
}

/**
 * Computes BOM items for Universal Skirt Rail (83" rails, frame mounts, splice connectors, spacers, end caps).
 */
export function computeSkirtRailBomItems(params: UniversalSkirtRailBomParams): Item[] {
  const { bottomRowLengthMm, designSnowLoad = 0, skirtRailSpacer } = params
  const skirtRailLengthMm = SKIRT_RAIL_LENGTH_INCHES * MM_PER_INCH
  const numSkirtRails = Math.ceil(bottomRowLengthMm / skirtRailLengthMm)
  const frameMountsPerRail = designSnowLoad <= SNOW_LOAD_PSF_THRESHOLD ? 2 : 3
  const totalFrameMounts = numSkirtRails * frameMountsPerRail
  const numSplices = Math.max(0, numSkirtRails - 1)
  const spacerCode = skirtRailSpacer || DEFAULT_SKIRT_SPACER_CODE
  const totalSpacers = numSplices * 2

  return [
    ...bomItems(UNIVERSAL_SKIRT_RAIL_83_CODE, numSkirtRails),
    ...bomItems(SKIRT_FRAME_MOUNT_CODE, totalFrameMounts),
    ...bomItems(SKIRT_SPLICE_CONNECTOR_CODE, numSplices),
    ...bomItems(spacerCode, totalSpacers),
    ...bomItems(SKIRT_END_CAP_CODE, 2),
  ]
}
